import { getCookie } from '@alexis/helpers/cookie';
import { genzoTrackActionEvent } from '@alexis/helpers/genzo';
import { useSelector } from 'react-redux';

import { getUserState } from '@redux/selectors';

const useTravellersTrackingActions = (pageViewId: string) => {
  const user = useSelector(getUserState);
  const wegoAnalyticsClientId = getCookie('wego_analytics_client_id');
  const wegoAnalyticsClientSessionId = getCookie('wego_analytics_client_session_id');

  const trackTravellerClickAction = (object: string) => {
    if (wegoAnalyticsClientId && wegoAnalyticsClientSessionId) {
      genzoTrackActionEvent(
        API_BASE_URL,
        wegoAnalyticsClientId,
        wegoAnalyticsClientSessionId,
        user?.userHash,
        {
          id: pageViewId,
          category: 'traveler_form',
          object,
          action: 'clicked',
          value: '',
        },
      );
    }
  };

  const trackClickRemoveTraveller = () => {
    trackTravellerClickAction('del_traveler');
  };
  const trackClickSaveTraveller = () => {
    trackTravellerClickAction('save_traveler');
  };
  const trackClickAddNewTraveller = () => {
    trackTravellerClickAction('add_traveler');
  };
  return {
    trackClickRemoveTraveller,
    trackClickSaveTraveller,
    trackClickAddNewTraveller,
  };
};

export default useTravellersTrackingActions;
